export interface Materiality {
  id: number;
  name: string;
}

export interface CategoryData {
  id: number;
  code: string;
  min_age_months: number;
  max_age_months: number;
}

export const MATERIALITIES: Materiality[] = [
  { id: 1, name: "Capa dura" },
  { id: 2, name: "Brochura" },
  { id: 3, name: "Pano" },
  { id: 4, name: "Banho" },
  { id: 5, name: "Cartonado sem interatividade" },
  { id: 6, name: "Cartonado recortes progressivos" },
  { id: 7, name: "Cartonado recortes" },
  { id: 8, name: "Cartonado abas" },
  { id: 9, name: "Cartonado disco giratório" },
  { id: 10, name: "Cartonado formas rotativas" },
  { id: 11, name: "Cartonado deslize" },
  { id: 12, name: "Cartonado apito" },
  { id: 13, name: "Cartonado toque e sinta" },
  { id: 14, name: "Cartonado puxe e empurre" },
  { id: 15, name: "Cartonado quebra-cabeça" },
  { id: 16, name: "Cartonado tabs" },
  { id: 17, name: "Cartonado puxe e ache" },
  { id: 18, name: "Cartonado pop-up" },
  { id: 19, name: "Cartonado sanfonado" },
  { id: 20, name: "Cartonado trilhas" },
  { id: 21, name: "Cartonado chocalho" },
  { id: 22, name: "Cartonado dedoches" },
];

// CATEGORIES agora vem da API via hook useCategoriesData
// Use o hook useCategoriesData() nos componentes que precisam dos dados

export function getMaterialityName(id: number): string {
  return MATERIALITIES.find((m) => m.id === id)?.name || "";
}

export function getMaterialityId(name: string): number {
  return MATERIALITIES.find((m) => m.name === name)?.id || 0;
}
